/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_Copilotheading1Inputs */

const zh_landing_hero_copilotheading1 = /** @type {(inputs: Landing_Hero_Copilotheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在一个轻量工作区里创建课程、测验，并跟踪学生进度`)
};

const en_landing_hero_copilotheading1 = /** @type {(inputs: Landing_Hero_Copilotheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create lessons, quizzes, and track student progress in one easy workspace`)
};

const es_landing_hero_copilotheading1 = /** @type {(inputs: Landing_Hero_Copilotheading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea lecciones, cuestionarios y sigue el progreso de los estudiantes en un solo espacio fácil`)
};

/**
* | output |
* | --- |
* | "Create lessons, quizzes, and track student progress in one easy workspace" |
*
* @param {Landing_Hero_Copilotheading1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_hero_copilotheading1 = /** @type {((inputs?: Landing_Hero_Copilotheading1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_Copilotheading1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_hero_copilotheading1(inputs)
	if (locale === "en") return en_landing_hero_copilotheading1(inputs)
	return es_landing_hero_copilotheading1(inputs)
});
export { landing_hero_copilotheading1 as "landing_hero_copilotHeading" }